/**
 * Course player breadcrumbs.
 */
import React, { useMemo } from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import { Link, useParams } from "react-router-dom";

import { useAsterController } from "context";
import { VButton } from "form";
import { getSectionTitle, getSequenceTitle } from "utils/course";

/**
 * Shows section, sequence, and vertical titles for the current unit.
 */
const BoardBreadCrumb = () => {
  const { courseId, sectionIndex, sequenceIndex } = useParams();

  const [controller] = useAsterController();
  const { structure } = controller;

  const sectionTitle = useMemo(() => getSectionTitle(structure, sectionIndex), [structure, sectionIndex]);
  const sequenceTitle = useMemo(() => getSequenceTitle(structure, sectionIndex, sequenceIndex), [structure, sectionIndex, sequenceIndex]);

  return (
    <>
      <Box className="hidden md:flex items-center mt-2">
        <Link to="/dashboard" className="no-underline" style={{ marginLeft: "-15px" }}>
          <VButton variant="text" iconOnly color="primary">
            <Icon icon="codicon:home" className="text-xl cursor-pointer font-bold" />
          </VButton>
        </Link>
        <Icon icon="bi:chevron-right" className="text-xs dark:text-gray-500" />

        <Link to={`/course/${courseId}`} className="no-underline">
          <VButton variant="text" color="primary" className="text-sm">
            {sectionTitle}
          </VButton>
        </Link>
        <Icon icon="bi:chevron-right" className="text-xs dark:text-gray-500" />

        <VButton variant="text" color="secondary" className="text-sm">
          {sequenceTitle}
        </VButton>
      </Box>
    </>
  );
};

export default BoardBreadCrumb;
